export default ({ color = 'white' }) => (
  <svg
    className="arrow"
    width="35"
    height="33"
    viewBox="0 0 35 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 2L32.4796 31M32.4796 31V7.62245M32.4796 31H6.43878"
      stroke={color}
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
);
